class GoogleRatingBox extends HTMLElement {
  constructor(){ super(); this._els={}; this._lsMin='gBadgeMinimized'; this._lsSnooze='gBadgeDismissUntil'; }

  connectedCallback(){
    const p = location.pathname;
    if (p.startsWith('/checkout') || p.startsWith('/cart')) { this.remove(); return; }

    this.endpoint    = this.getAttribute('data-endpoint') || '';
    this.position    = (this.getAttribute('data-position') || 'br').toLowerCase();
    this.snoozeHours = parseInt(this.getAttribute('data-snooze-hours') || '24', 10);
    this.writeUrl    = this.getAttribute('data-write-url') || '';

    this.innerHTML = `
      <div class="grb ${this.position === 'bl' ? 'grb--bl' : 'grb--br'}">
        <div class="grb__card" hidden>
          <button class="grb__btn grb__btn--icon grb__btn--close" type="button" aria-label="Badge minimieren">×</button>

          <div class="grb__titlebar">
            <span class="grb__title">Google-Bewertungen</span>
          </div>

          <div class="grb__headingIcon" aria-hidden="true">
            <img src="https://shop.hinundhergestellt.de/cdn/shop/files/H_Icon_transparent_klein.png?v=1727715886&width=64">
          </div>

          <div class="grb__stack" role="group" aria-label="Bewertungsübersicht">
            <div class="grb__ratingNumber" aria-live="polite">–</div>

            <!-- Sterne: Basisschicht (grau) + Gold-Schicht (per width geclippt) -->
            <div class="grb__stars" style="--fill:0%">
              <span class="grb__starsBase" aria-hidden="true">
                <svg viewBox="0 0 110 22" focusable="false">
                  <defs><path id="s" d="M11 0l2.9 7.7 8.1.2-6.4 5 2.3 7.7L11 16.2 4.1 20.6l2.3-7.7L0 7.9l8.1-.2z"/></defs>
                  <use href="#s" x="0"/><use href="#s" x="22"/><use href="#s" x="44"/><use href="#s" x="66"/><use href="#s" x="88"/>
                </svg>
              </span>
              <span class="grb__starsFill" aria-hidden="true">
                <svg class="grb__starsGold" viewBox="0 0 110 22" focusable="false">
                  <use href="#s" x="0"/><use href="#s" x="22"/><use href="#s" x="44"/><use href="#s" x="66"/><use href="#s" x="88"/>
                </svg>
              </span>
            </div>

            <div class="grb__count" aria-label="Anzahl Bewertungen"> </div>

            <div class="grb__actions">
              <a class="button button--primary grb__btnPrimary" target="_blank" rel="noopener">Bewertung schreiben</a>
              <a class="grb__linkMore" target="_blank" rel="noopener">Bewertungen ansehen</a>
            </div>
          </div>
        </div>

        <!-- Launcher sichtbar lassen als Fallback -->
        <button class="grb__launcher" type="button" aria-label="Google-Badge öffnen">
          ★ <span class="grb__launcherScore">–</span>
        </button>
      </div>
    `;

    // Refs
    this._els.card     = this.querySelector('.grb__card');
    this._els.launcher = this.querySelector('.grb__launcher');
    this._els.lScore   = this.querySelector('.grb__launcherScore');
    this._els.stars    = this.querySelector('.grb__stars');
    this._els.number   = this.querySelector('.grb__ratingNumber');
    this._els.count    = this.querySelector('.grb__count');
    this._els.btnMin   = this.querySelector('.grb__btn--min');
    this._els.btnClose = this.querySelector('.grb__btn--close');
    this._els.btnWrite = this.querySelector('.grb__btnPrimary');
    this._els.linkMore = this.querySelector('.grb__linkMore');

    // State & Initial
    const snoozeUntil = this._getInt(this._lsSnooze);
    this._isSnoozed = snoozeUntil && snoozeUntil > Date.now();
    this._minimized = this._getBool(this._lsMin) || matchMedia('(max-width: 767px)').matches;
    if (this._isSnoozed) this._hideAll(); else (this._minimized ? this._showMin() : this._showCard());

    // Daten
    if (this.endpoint) this._fetchData(); else console.warn('GoogleRatingBox: data-endpoint fehlt.');

    // Events
    this._els.btnMin?.addEventListener('click', () => this._showMin());
    this._els.btnClose?.addEventListener('click', () => this._showMin());
    this._els.launcher?.addEventListener('click', () => this._showCard());
  }

  _showCard(){ if(this._isSnoozed) return; this._els.card.hidden=false; this._els.launcher.hidden=true;  this._minimized=false; this._set(this._lsMin,'0'); }
  _showMin(){  if(this._isSnoozed) return; this._els.card.hidden=true;  this._els.launcher.hidden=false; this._minimized=true;  this._set(this._lsMin,'1'); }
  _hideAll(){  this._els.card.hidden=true; this._els.launcher.hidden=true; }

  _snooze(){ const ms=this.snoozeHours*3600*1000; this._set(this._lsSnooze,String(Date.now()+ms)); this._hideAll(); this._isSnoozed=true; }

  _fetchData(){
    fetch(this.endpoint,{credentials:'omit', cache:'no-store'})
      .then(r=>r.ok?r.json():Promise.reject(new Error('Bad status')))
      .then(d=>{
        if(!d || d.rating==null) return;
        const rating = Number(d.rating) || 0;
        const pct = Math.max(0, Math.min(100, (Math.round(rating*2)/10)*100));
        const count = Number(d.count)||0;

        const text = rating.toFixed(1).replace('.', ',');
        this._els.number.textContent = text;
        this._els.lScore.textContent = text;
        this._els.count.textContent = `(${count.toLocaleString('de-DE')})`;

        // Sterne füllen (Breite des goldenen Layers)
        this._els.stars.style.setProperty('--fill', pct + '%');

        // Links
        const viewUrl  = d.url || '';
        const writeUrl = this.writeUrl || d.write_url || viewUrl;
        if (viewUrl)  this._els.linkMore.href = viewUrl;
        if (writeUrl) this._els.btnWrite.href = writeUrl;

        if(!this._isSnoozed) (this._minimized ? this._showMin() : this._showCard());

        this._injectAggregateSchema({ ratingValue: rating, ratingCount: count, viewUrl: viewUrl })
      })
      .catch(err => { console.warn('GoogleRatingBox fetch failed:', err); this._showMin(); });
  }

    _injectAggregateSchema({ ratingValue, ratingCount, viewUrl }) {
        try {
            const name = this.getAttribute('data-business-name') || document.title || '';
            const url  = this.getAttribute('data-business-url')  || location.origin;
            const type = (this.getAttribute('data-business-type') || 'Organization').trim();

            if (!ratingValue || !ratingCount) return;

            const payload = {
            "@context": "https://schema.org",
            "@type": type,
            "name": name,
            "url": url,
            "aggregateRating": {
                "@type": "AggregateRating",
                "ratingValue": Number(ratingValue),
                "ratingCount": Number(ratingCount)
            }
            };

            if (viewUrl) payload.sameAs = [String(viewUrl)];

            // vorhandenes Script ersetzen
            const id = "grb-schema";
            let node = document.getElementById(id);
            if (!node) {
            node = document.createElement('script');
            node.type = 'application/ld+json';
            node.id = id;
            document.head.appendChild(node);
            }
            node.textContent = JSON.stringify(payload);
        } catch (e) {
            console.warn('AggregateRating JSON-LD failed:', e);
        }
    }

  _getInt(k){ try{ return parseInt(localStorage.getItem(k)||'0',10)||0; }catch{ return 0; } }
  _getBool(k){ try{ return localStorage.getItem(k)==='1'; }catch{ return false; } }
  _set(k,v){ try{ localStorage.setItem(k,String(v)); }catch{} }
}
customElements.define('google-rating-box', GoogleRatingBox);
